import { EventEmitter } from '@angular/core';
import * as moment from 'moment';
var OrderhistoryPageComponent = /** @class */ (function () {
    function OrderhistoryPageComponent() {
        this.onExpand = new EventEmitter();
    }
    Object.defineProperty(OrderhistoryPageComponent.prototype, "hasOrders", {
        get: function () {
            return this.orderHistory.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    OrderhistoryPageComponent.prototype.orderedOn = function (input) {
        var date = moment(input);
        var retValue = '';
        if (date.isValid()) {
            retValue = moment(input).format('DD-MM-YYYY HH:mm');
        }
        return retValue;
    };
    OrderhistoryPageComponent.prototype.expand = function () {
        this.onExpand.emit();
    };
    return OrderhistoryPageComponent;
}());
export { OrderhistoryPageComponent };
